import React from "react";
import {
  NORMAL_ROUND_BUTTONS,
  NORMAL_ROUND_GROUPS,
  groupRoundButtons,
} from "../../config/admissionRound";
import RoundImageRows from "./RoundImageRows";

// รูปปุ่มรอบภาคปกติ — สลับปีโฟลเดอร์ได้ที่นี่
// เปิด-ปิดรอบ / ผูก ROB_ID แก้ที่ config/admissionRound.js
import rob1 from "../../assets/2027/normall/rob1.png";
import rob2 from "../../assets/2027/normall/rob2.png";
import rob3 from "../../assets/2027/normall/rob3.png";
import rob4 from "../../assets/2027/normall/rob4.png";
import rob5 from "../../assets/2027/normall/rob5.png";
import nrob1 from "../../assets/2027/normall/nrob1.png";
import nrob2 from "../../assets/2027/normall/nrob2.png";

const IMAGES = { rob1, rob2, rob3, rob4, rob5, nrob1, nrob2 };

/** ปริญญาตรี ภาคปกติ (จันทร์-ศุกร์) + หลักสูตรพยาบาลศาสตรบัณฑิต — /Register/1 */
function NormalRounds({ selectedRobId, onSelect }) {
  const groups = groupRoundButtons(
    NORMAL_ROUND_BUTTONS,
    NORMAL_ROUND_GROUPS,
    IMAGES
  );

  if (groups.length === 0) {
    return <p className="reg-empty">ยังไม่มีรอบเปิดสมัครเรียน</p>;
  }

  return (
    <RoundImageRows
      groups={groups}
      selectedRobId={selectedRobId}
      onSelect={onSelect}
    />
  );
}

export default NormalRounds;
